export default __webpack_public_path__ + "static/media/nft6.7b56353e.jpg";